// extracted by mini-css-extract-plugin
export default {"line":"line--iycrqEo8M5","icon":"icon--hHrSgkOEZ-","label":"label--02GCea8OnV","description":"description--bs1X0wtnpx"};